import { computed } from "vue";
import { language } from "@/language";
import { useBaseStore } from "@store/base";

export default function () {
  const base = useBaseStore();
  const lang = computed(() => base.lang);
  const defaultLang = computed(() => base.defaultLang);
  const changeLang = (lang) => {
    language.setLang(lang);
    base.setLang(lang);
  };

  const getLangPackByKey = (key) => {
    return base?.langPack?.[lang.value]?.[key] || "";
  };

  return {
    lang,
    defaultLang,
    changeLang,
    getLangPackByKey,
  };
}
